import React, { useState } from 'react';

export const isUatEnvironment = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return host.includes('witty-desert') || host.includes('uat') || host.includes('staging');
};

const EnvironmentBanner: React.FC = () => {
  const isUat = isUatEnvironment();
  const [isMinimized, setIsMinimized] = useState(() => {
    return sessionStorage.getItem('synclothe_uat_banner_minimized') === 'true';
  });

  if (!isUat) return null;

  const toggleMinimize = () => {
    const next = !isMinimized;
    setIsMinimized(next);
    try {
      sessionStorage.setItem('synclothe_uat_banner_minimized', String(next));
    } catch (e) {}
  };

  if (isMinimized) {
    return (
      <div className="fixed top-2 right-2 z-50 animate-fade-in select-none">
        <button
          onClick={toggleMinimize}
          type="button"
          title="Click to expand UAT Sandbox details"
          className="flex items-center gap-1.5 px-2.5 py-1 bg-[#120e06]/90 border border-amber-500/50 rounded-full backdrop-blur-md shadow-lg shadow-black/60 hover:border-amber-400 text-amber-300 text-[9px] font-black uppercase tracking-widest transition-all cursor-pointer group"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></span>
          <span>UAT Sandbox</span>
          <span className="text-[8px] text-amber-500 group-hover:text-amber-300">&darr;</span>
        </button>
      </div>
    );
  }

  return (
    <div className="relative z-50 bg-[#120e06] border-b border-amber-500/30 text-amber-200/90 py-1.5 px-4 text-xs select-none backdrop-blur-md">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        
        {/* Left Side: Pulse + Description */}
        <div className="flex items-center gap-2.5 flex-wrap">
          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-amber-500/20 border border-amber-500/40 text-[8px] md:text-[9px] font-black uppercase tracking-widest text-amber-400">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></span>
            UAT Testbed
          </span>

          <span className="text-[10px] md:text-xs font-mono font-medium tracking-tight text-amber-200/90">
            Sandbox Active: Isolated DB (<span className="text-amber-400 font-bold">SynclotheDB_UAT</span>) & Storage (<span className="text-amber-400 font-bold">wardrobe-uat</span>). Production data is untouched.
          </span>
        </div>

        {/* Right Side: Minimize Button */}
        <button
          onClick={toggleMinimize}
          type="button"
          className="text-[9px] font-mono uppercase tracking-widest text-amber-400/80 hover:text-amber-300 hover:underline cursor-pointer flex-shrink-0"
        >
          [Minimize &uarr;]
        </button>
      </div>
    </div>
  );
};

export default EnvironmentBanner;
